(function ()
{
  var myVar = setInterval(timer, 300);
  function timer()
  {
    if (window.jQuery)
    {
      $(document).ready(function ()
      {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js";
        document.getElementsByTagName("head")[0].appendChild(script);
        if ((window.location.href.indexOf("rewards") > -1) || (window.location.href.indexOf("refer") > -1))
        {
          $("body").addClass("swell-rewards");
        }
        $(document).on('swell:initialized', function ()
        {
          swellCampaignsList();
          removeLoader("campaign");
        });
        $(document).on('swell:setup', function ()
        {
          Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
          SwellConfig.Referral.populateRedemptionOffers();
          removeLoader("refer");
          $(".swell-post-checkout").css("display", "flex");
          SwellConfig.Tier.initializeCustomTierProperties();
          SwellConfig.Tier.initializeTiers(".swell-tier-list");
          SwellConfig.Tier.setupSlickSlider();
          removeLoader("tiers");
        });
        $(document).on("swell:referral:success", function ()
        {
          swellAPI.refreshCustomerDetails(function ()
          {
            $(".table-data").html("");
            SwellConfig.Referral.populateRedemptionOffers();
          });
        });
        $("body").on("click", ".swell-share-referral-copy", function ()
        {
          setTimeout(function ()
          {
            $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://", ""));
            $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("https://", ""));
            $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html() + "?c");
          }, 20);
        });
        $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown)
        {
          if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED")
          {
            $(".refer-customer-error").remove();
            $(".swell-referral-form-list").before('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
          }
          if (textStatus && textStatus === "Please enter a valid email address")
          {
            $(".refer-customer-error").remove();
            $(".swell-referral-form-list").before('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
          }
        });
        $('body').on('click', '.swell-referral-copy', function (e)
        {
          if ($(e.target).hasClass("swell-referral-copy"))
          {
            e.stopPropagation();
          }
        });
        $('body').on('click', '.referral-section .referral-section-holder .swell-referral-holder .refer-options .swell-link-list .swell-link .referral', function ()
        {
          $(".referral-section .referral-section-holder .swell-referral-holder .swell-referral").css("display", "none");
          $(".referral-section .referral-section-holder .swell-referral-holder .referral-sidebar-content-outer-holder").css("display", "flex");
          $(".referral-section .referral-section-holder .swell-referral-holder .refer-options .swell-link-list .swell-link .referral").addClass("active");
          $(".referral-section .referral-section-holder .swell-referral-holder .refer-options .swell-link-list .swell-link .refer-friend-btn").removeClass("active");
        });

        $('body').on('click', '.referral-section .referral-section-holder .swell-referral-holder .refer-options .swell-link-list .swell-link .refer-friend-btn', function ()
        {
          $(".referral-section .referral-section-holder .swell-referral-holder .referral-sidebar-content-outer-holder").css("display", "none");
          $(".referral-section .referral-section-holder .swell-referral-holder .swell-referral").css("display", "flex");
          $(".referral-section .referral-section-holder .swell-referral-holder .refer-options .swell-link-list .swell-link .refer-friend-btn").addClass("active");
          $(".referral-section .referral-section-holder .swell-referral-holder .refer-options .swell-link-list .swell-link .referral").removeClass("active");
        });
        $("body").on("click", ".checkout-heading .swell-referral-back-link", function ()
        {
          $(".swell-post-checkout").css("display", "none");
        });
      });
      stop();
    }
  }
  function stop()
  {
    clearInterval(myVar);
  }
}).call(this);

(function ()
{
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Referral = {
    opts:
    {
      localization:
      {
        referralSidebarDetailsAction: "REFER A FRIEND",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: "give $15, Get $15",
        referralRegisterFormDetails: "Enter your email to get started...",
        referralRegisterFormEmail: "Enter your email",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "Give your friends $15 off their first purchase of $50 or more and get $15 in points for each successful referral.",

        referralReferHeading: "give $15, Get $15",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, enter your friends’ emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "Give your friends $15 off their first purchase of $50 or more and get $15 in points for each successful referral.",
        referralReferMediaDetails: "",

        referralShareFacebook: "Share",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Message",
        referralShareTwitter: "Tweet",
        referralShareSMS: "SMS",

        referralReferMediaIcon: "swell-referral-media-icon swell-icon-facebook-share",
        referralLinkIcon: "swell-referral-media-icon swell-icon-copylink",
        referralMessengerIcon: "swell-referral-media-icon swell-icon-fb-message",
        referralTwitterIcon: "swell-referral-media-icon swell-icon-tweet",
        referralSMSIcon: "swell-referral-media-icon swell-icon-sms",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "COPY LINK",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates:
      {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><span class="refer-friend"><%= localization.referralSidebarDetailsAction %></span><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails%></p><div class="swell-border"></div><div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails%></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><span class="refer-friend"><%= localization.referralSidebarDetailsAction %></span><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails%></p><div class="swell-border"></div><div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails%></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralReferMediaIcon %>" aria-hidden="true"></i> <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralSMSIcon %>" aria-hidden="true"></i> <%= localization.referralShareSMS %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralMessengerIcon %>" aria-hidden="true"></i> <%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralTwitterIcon %>" aria-hidden="true"></i> <%= localization.referralShareTwitter %> </div> </li>  <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralLinkIcon%>" aria-hidden="true"></i> <%= localization.referralShareCopy%> </div> </li>  </ul> </div> </div>',
      }
    },
    populateRedemptionOffers: function ()
    {
      if (spapi.authenticated)
      {
        var receipts = spapi.customer.referral_receipts;
        var email;
        var completed_at;
        var status;
        var rewards_points;
        var count = 0;
        receipts.forEach(function (ref_receipts)
        {
          email = ref_receipts.email;
          completed_at = ref_receipts.completed_at;
          rewards_points = spapi.activeReferralCampaign.reward_text;
          if (completed_at)
          {
            status = "Completed";
            count++;
          }
          else
          {
            status = "Pending";
          }
          $(".table-data").append("<tr> <td> " + email + "</td> <td class='swell-status'>" + status + "</td></tr>");
        });
        $(".earning-amount").html("$" + (count * 5) + " in points");
      }
    }
  };
}).call(this);

function swellCampaignsList()
{
  var campaigns = spapi.activeCampaigns;
  campaigns.forEach(function (campaign)
  {
    if (campaign.type != "ReferralCampaign" && campaign.type != "YotpoReviewCampaign" && campaign.id != "550166")
    {
      $('.swell-campaign-list').append('<li class="swell-campaign"> <div class="swell-campaign-content swell-campaign-link" data-display-mode="modal" data-campaign-id=' + campaign.id + '> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class="' + campaign.icon + '"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">' + campaign.reward_text + '</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">' + campaign.title + '</span> </div> </div> </li>');
    }

  });
};

(function ()
{
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getCustomerTierRank: function ()
    {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id)
      {
        rank = jQuery.grep(tiers, function (e)
        {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      }
      else
      {
        intro_tier = jQuery.grep(tiers, function (e)
        {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0)
        {
          return intro_tier[0].rank;
        }
        else
        {
          return null;
        }
      }
    },
    getCustomerTierId: function ()
    {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier)
      {
        return customer_tier.id;
      }
      else
      {
        intro_tier = jQuery.grep(tiers, function (e)
        {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0)
        {
          return intro_tier[0].id;
        }
        else
        {
          return null;
        }
      }
    },
    getTierByRank: function (rank)
    {
      var tiers;
      tiers = spapi.activeVipTiers;
      return jQuery.grep(tiers, function (e)
      {
        return e.rank === rank;
      })[0];
    },
    initializeCustomTierProperties: function ()
    {
      spapi.activeVipTiers[0].spendPoints = "Make " + spapi.activeVipTiers[0].referrals_completed + " successful referrals per rolling year",
      spapi.activeVipTiers[0].namePoints = spapi.activeVipTiers[0].name,
      spapi.activeVipTiers[0].icon = "<img src='//passionplanner.com/cdn/shop/t/67/assets/swell-bronze-new.svg?v=173765118871160275011693286745'>",
      spapi.activeVipTiers[0].benefit1 = "- Earn 1.25x points per dollar spent",

      spapi.activeVipTiers[1].spendPoints = "Make " + spapi.activeVipTiers[1].referrals_completed + " successful referrals per rolling year",
      spapi.activeVipTiers[1].namePoints = spapi.activeVipTiers[1].name,
      spapi.activeVipTiers[1].icon = "<img src='//passionplanner.com/cdn/shop/t/67/assets/swell-silver-updated.svg?v=154706859254179754561693286745'>",
      spapi.activeVipTiers[1].benefit1 = "- Earn 1.5x points per dollar spent",

      spapi.activeVipTiers[2].spendPoints = "Make " + spapi.activeVipTiers[2].referrals_completed + " successful referrals per rolling year",
      spapi.activeVipTiers[2].namePoints = spapi.activeVipTiers[2].name,
      spapi.activeVipTiers[2].icon = "<img src='//passionplanner.com/cdn/shop/t/67/assets/swell-gold-new.svg?v=93052283026247245301693286745'>",
      spapi.activeVipTiers[2].benefit1 = "- Earn 2x points per dollar spent"
    },
    initializeTiers: function (containerSelector)
    {
      var count = 0;
      tiers = spapi.activeVipTiers;
      tiers.forEach(function (tier)
      {
       $(containerSelector).append("<li data-tier-id=" + tier.id + " class = 'list-items tier" + count + " tier-list-item'> <div class= 'items-holder'> <div class='items-heading-holder'> <div class='tier-name'>" + tier.namePoints + "</div> <div class='tier-spend'>" + tier.icon + "</div> </div> <span class='make-purchases'>" + tier.spendPoints + "</span> <ul class='point-holder'> <li><span>" + tier.benefit1 + "</span></li> </div> </li>");
        count++;
      });
      if (spapi.authenticated)
      {
        SwellConfig.Tier.setupCustomerTierStatus();
      }
    },
    setupCustomerTierStatus: function ()
    {
      var toGoNext, next_tier;
      var last_tier = spapi.activeVipTiers.length;
      var last_tier_rank = SwellConfig.Tier.getTierByRank(last_tier - 1);
      $(".swell-tier-list .list-items .items-heading-holder").prepend("<div class='swell-tier-status'></div>");
      $(".swell-tier-list .list-items").prepend("<div class='customer-spend-more'></div>");
      if (spapi.customer.vip_tier)
      {
        var $customer_tier_id, $customer_tier_rank;
        customer_tier_id = SwellConfig.Tier.getCustomerTierId();
        customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
        tiers = spapi.activeVipTiers;
        tiers.forEach(function (tier)
        {
          if (tier.id == customer_tier_id)
          {
            customer_tier = tier;
          }
        });
        if (last_tier_rank.rank == customer_tier_rank)
        {
          tiers.forEach(function (tier)
          {
            if (tier.rank == customer_tier.rank)
            {
              $("li[data-tier-id='" + tier.id + "'] .items-holder .items-heading-holder .swell-tier-status").append("Current Status");

            }
          });
        }
        else
        {
          next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
          toGoNext = (next_tier.referrals_completed - spapi.customer.vip_tier_stats.referrals_completed);
          if (toGoNext < 0)
          {
            toGoNext = 0;
          }
          tiers.forEach(function (tier)
          {
            if (tier.rank == customer_tier.rank)
            {
              $("li[data-tier-id='" + tier.id + "'] .items-holder .items-heading-holder .swell-tier-status").append("Current Status");
              $("li[data-tier-id='" + next_tier.id + "'] .customer-spend-more").append("Earn " + toGoNext + " more successful referrals to earn " + next_tier.name + "");

            }
          });
        }
      }
      else
      {
        next_tier = SwellConfig.Tier.getTierByRank(0);
        toGoNext = (next_tier.referrals_completed - spapi.customer.vip_tier_stats.referrals_completed);
        if (toGoNext < 0)
        {
          toGoNext = 0;
        }

        $("li[data-tier-id='" + next_tier.id + "'] .customer-spend-more").append("Earn " + toGoNext + " more successful referrals to earn " + next_tier.name + "");

      }
    },
    setupSlickSlider: function ()
    {
      $('.swell-tier-list').slick(
      {
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: null,
        prevArrow: null,
        arrows: false,
        dots: false,
        responsive: [
        {
          breakpoint: 768,
          settings:
          {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: "<img src='//passionplanner.com/cdn/shop/t/67/assets/swell-arrow-right.png?v=130413378809673946231693286745' class='slick-arrow-right'>",
            prevArrow: "<img src='//passionplanner.com/cdn/shop/t/67/assets/slick-left-arrow.png?13006' class='slick-arrow-left'>",
          }
        }]
      });
    }
  }
}).call(this);

function removeLoader(section)
{
  $(".swell-loader-spinner." + section).remove();
}
